<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="warning" icon="el-icon-sold-out" size="small" plain
            @click.stop="handleOutMore()">批量出库</el-button>
          <el-button type="primary" icon="el-icon-printer" size="small" plain @click.stop="printJson()">打印</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" plain
            @click.stop="downloadExcelStockRemoval">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="danger" icon="el-icon-d-arrow-left" size="small" plain
            v-if="scope.row.status == 'WAIT_OUT' || scope.row.status == '待出库'"
            @click.stop="handleReturn(scope.row, scope.index)">退回</el-button>
          <el-button type="primary" icon="el-icon-d-arrow-right" size="small" plain
            v-if="scope.row.status == 'WAIT_OUT' || scope.row.status == '待出库'"
            @click.stop="handleOut(scope.row, scope.index)">出库</el-button>
          <!-- 跳转页面查看 -->
          <!-- <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="serviceListing(scope.row)"
          >查看</el-button>-->
          <el-button type="success" icon="el-icon-view" size="small" plain
            @click.stop="dialogLook(scope.row)">查看</el-button>
        </template>
      </avue-crud>

      <el-dialog :visible.sync="reasonDialog" title="退回理由" center width="300px" style="index:9999">
        <div style="display: flex;">
          <el-input type="textarea" :rows="4" placeholder="请输入退回理由" v-model="remarks"></el-input>
        </div>
        <div class="typeButton">
          <el-button round size="mini" @click="reasonDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button round type="danger" size="mini"
            @click="typeEditOk">&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="lookDialog" center width="1000px" v-if="isOpen">
        <div class="stockwrap">
          <!--startprint-->
          <div v-bind="stockData" class="stockMain" id="printBox">
            <h1 class="stockMain title" id="printTitle" style="font-weight: Medium;color:#333;">采购出库单</h1>
            <div v-if="isPrint" id="printTime">
              <div>{{ "打印时间：" + handleFormatterDateToUTC(new Date().getTime()) }}</div>
              <div>{{ this.companyName }}</div>
            </div>
            <div class="stockMain content" id="content">
              <table border style="width:900px">
                <tr>
                  <th style="width:300px">采购入库单编号:</th>
                  <th style="width:300px;">{{ stockData.number }}</th>
                  <th style="width:300px">采购商户名称:</th>
                  <th style="width:300px">{{ stockData.shopName }}</th>
                </tr>
                <tr>
                  <th style="width:300px">法人姓名:</th>
                  <th style="width:300px">{{ stockData.name }}</th>
                  <th style="width:300px">店铺地址:</th>
                  <th style="width:300px">{{ stockData.address }}</th>
                </tr>
                <tr>
                  <th style="width:300px">采购时间:</th>
                  <th style="width:300px">{{ handleFormatterDateToUTC(stockData.createTime) }}</th>
                  <th style="width:300px">商品数量共计:</th>
                  <th style="width:300px">{{ stockData.goodsAmount }}</th>
                </tr>
                <tr>
                  <th style="width:300px">采购金额:</th>
                  <th style="width:300px">{{ stockData.price }}</th>
                  <th style="width:300px">支付状态:</th>
                  <th style="width:300px">{{ stockData.payStatus == 'WAIT_PAY' ? '待付款' : (stockData.payStatus ==
                    'WAIT_OUT'
                    ? '待出库' : (stockData.payStatus == 'WAIT_CONFIRM' ? '待收货' : (stockData.payStatus == 'RETURNED' ? '已退回'
                      :
                      (stockData.payStatus == 'FINISH' ? '已完成' : (stockData.payStatus == 'INVALID' ? '已失效' :
                        (stockData.payStatus == 'CANCELED' ? '已取消' : (stockData.payStatus == 'WAIT_REFUND' ?
                          '待退款' : 'StatusError:' + stockData.payStatus))))))) }}</th>
                </tr>
                <tr>
                  <th style="width:300px">结算方式:</th>
                  <th style="width:300px">{{ stockData.clearingType == "INSTALLMENT" ? "月结" : "现款现货" }}</th>
                  <th style="width:300px">订单状态:</th>
                  <th style="width:300px">{{ stockData.status == 'WAIT_PAY' ? '待付款' : (stockData.status == 'WAIT_OUT' ?
                    '待出库' : (stockData.status == 'WAIT_CONFIRM' ? '待收货' : (stockData.status == 'RETURNED' ? '已退回' :
                      (stockData.status == 'FINISH' ? '已完成' : (stockData.status == 'INVALID' ? '已失效' : (stockData.status ==
                        'CANCELED' ? '已取消' : ('StatusError:' + stockData.status))))))) }}</th>
                </tr>
                <tr v-if="stockData.status == 'WAIT_OUT'"></tr>
                <tr v-if="stockData.status == 'RETURNED'">
                  <th style="width:300px" v-if="stockData.remarks">退回原因:</th>
                  <th style="width:300px" v-if="stockData.remarks">{{ stockData.remarks }}</th>
                  <th style="width:300px" v-if="stockData.handleTime">退回时间:</th>
                  <th style="width:300px" v-if="stockData.handleTime">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                </tr>
                <tr v-if="stockData.status == 'WAIT_CONFIRM'">
                  <th style="width:300px" v-if="stockData.handleTime">出库时间:</th>
                  <th style="width:300px" v-if="stockData.handleTime">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                  <th></th>
                  <th></th>
                </tr>
                <tr v-if="stockData.status == 'WAIT_PAY'">
                  <th style="width:300px" v-if="stockData.handleTime">出库时间:</th>
                  <th style="width:300px" v-if="stockData.handleTime">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                  <th style="width:300px" v-if="stockData.confirmTime">收货时间:</th>
                  <th style="width:300px" v-if="stockData.confirmTime">
                    {{ stockData.confirmTime ? handleFormatterDateToUTC(stockData.confirmTime) : stockData.confirmTime }}
                  </th>
                </tr>
                <tr v-if="stockData.status == 'FINISH'">
                  <th style="width:300px" v-if="stockData.handleTime">出库时间:</th>
                  <th style="width:300px" v-if="stockData.handleTime">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                  <th style="width:300px" v-if="stockData.confirmTime">收货时间:</th>
                  <th style="width:300px" v-if="stockData.confirmTime">
                    {{ stockData.confirmTime ? handleFormatterDateToUTC(stockData.confirmTime) : stockData.confirmTime }}
                  </th>
                </tr>
                <tr v-if="stockData.status == 'FINISH'">
                  <th style="width:300px" v-if="stockData.payTime">支付时间:</th>
                  <th style="width:300px" v-if="stockData.payTime">
                    {{ stockData.payTime ? handleFormatterDateToUTC(stockData.payTime) : stockData.payTime }}</th>
                  <th></th>
                  <th></th>
                </tr>

                <tr>
                  <th style="width:300px" v-if="stockData.status == 'CANCELED'">取消时间:</th>
                  <th style="width:300px" v-if="stockData.status == 'CANCELED'">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                  <th style="width:300px" v-if="stockData.status == 'INVALID'">失效时间:</th>
                  <th style="width:300px" v-if="stockData.status == 'INVALID'">
                    {{ stockData.handleTime ? handleFormatterDateToUTC(stockData.handleTime) : stockData.handleTime }}
                  </th>
                </tr>
              </table>
              <avue-crud :option="table1Option" :data="table1Data" :table-loading="tableLoading" border ref="crud"
                style="width:auto;margin:0;margin-top:15px"></avue-crud>
            </div>
            <div class="stockMain btn" id="noprint">
              <!-- <el-button
              @click="doPdf"
              v-if="stockData.status !='CANCELED' && stockData.status !='INVALID'"
              >下载PDF</el-button>-->
              <el-button @click="doPrint" v-if="stockData.status != 'CANCELED' && stockData.status != 'INVALID'">打印 /
                另存为PDF</el-button>
              <el-button v-if="stockData.status == 'WAIT_OUT'" @click="reasonDialog = true">退回</el-button>
              <el-button v-if="stockData.status == 'WAIT_OUT'" @click="handleDetailOut">出库</el-button>
              <el-button
                v-if="stockData.payStatus == 'WAIT_PAY' && stockData.status == 'WAIT_CONFIRM' || stockData.status == 'WAIT_PAY'"
                @click="toArDetail">查看应收款</el-button>
            </div>
          </div>
          <!--endprint-->
          <!-- <el-dialog :visible.sync="reasonDialog" title="退回理由" center width="300px"> -->
          <!-- <div style="display: flex;">
            <el-input type="textarea" :rows="4" placeholder="请输入退回理由" v-model="remarks"></el-input>
          </div>
          <div class="typeButton">
            <el-button
              round
              size="mini"
              @click="reasonDialog = false"
            >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
            <el-button
              round
              type="danger"
              size="mini"
              @click="typeEditOk"
            >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
          </div>-->
          <!-- </el-dialog> -->
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { stockRemovalOption } from "@/const/salesCloud/stockRemovalOption";
import {
  statusSearch,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findItemsByCategory,
  userPass,
  userRefused,
  cancelWorkOrder,
} from "@/api/salesCloud/workOrder";
import { getCompany } from "@/util/auth";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import {
  invoiceSystemV2Purchase,
  invoiceSystemV2PurchaseOut,
  invoiceSystemV2PurchaseDownloadExcel,
  invoiceSystemV2PurchaseReturned,
  invoiceSystemV2PurchaseDetail,
  downloadPDF,
} from "@/api/salesCloud/stockRemoval";
import { stockFormOption } from "@/const/salesCloud/stockFormOption";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { baseUrl } from "@/config/env";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { exportExcel } from "xlsx-oc";
import { excelaxios } from "@/util/excelaxios";
// import { jsPDF } from "@/util/jsPDF";
import { log } from "util";

export default {
  name: "stockRemoval",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: stockRemovalOption, //表格设置属性
      table1Option: stockFormOption,
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      reasonDialog: false,
      lookDialog: false,
      isOpen: false,
      isPrint: false,
      stockData: {},
      companyName: "",
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      remarks: "",
      status: "",
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {},
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    toArDetail() {
      // console.log(this.stockData);
      let params = {
        arNumber: this.stockData.arNumber,
        id: this.stockData.shopId,
      };
      // console.log(params);
      this.$router.push({ name: "应收款详情", params });
    },
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    dialogLook(row) {
      this.lookDialog = true;
      this.rowId = row.id;
      // console.log(this);
      invoiceSystemV2PurchaseDetail(this.rowId).then((res) => {
        // console.log(res);
        let data = JSON.parse(res.data);
        // console.log(this);
        // console.log("findStockRemovalDetail", data);
        // data.purchaseTime = this.handleFormatterDateToUTC(data.purchaseTime);
        this.stockData = data;
        // console.log(data);
        this.table1Data = data.goods;
        this.isOpen = true;
        // this.page = {
        //   total: data.total,
        //   currentPage: this.page.currentPage,
        //   pageSize: this.page.pageSize
        // };
        this.tableLoading = false;
      });
    },
    handleOutMore() {
      // console.log(this.$refs.crud.tableSelect);
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认批量出库?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          // console.log(ids);
          invoiceSystemV2PurchaseOut(ids)
            .then((res) => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "批量出库成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    handleDetailOut() {
      invoiceSystemV2PurchaseOut(this.rowId).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "出库成功",
            type: "success",
          });
          this.handleList();
          this.lookDialog = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    handleOut(row, index) {
      // console.log(row);
      this.rowId = row.id;
      invoiceSystemV2PurchaseOut(this.rowId).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "出库成功",
            type: "success",
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
      // this.evaluateDialog =true
      // console.log(row, index);
      // console.log(this);
    },

    statusChange() {
      //下拉框状态发生改变时
      //console.log(this.value);
      let params = this.value;
      statusSearch(params).then((res) => {
        let data = JSON.parse(res.data);
        // console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      this.downloadData = params;
      // console.log(this.downloadData);
      // console.log(params);
      // console.log(params, "搜索条件");
      // console.log(this);
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        params.startTime = "";
        params.endTime = "";
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      // console.log(page);
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) { },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleReturn(row, index) {
      this.remarks = "";
      this.reasonDialog = true;
      this.rowId = row.id;
      this.currIndex = index;
      // console.log("currIndex", this);
    },
    typeEditOk() {
      // console.log(this.rowId);
      let params = {
        reason: this.remarks,
      };
      if (this.remarks.replace(/(^\s+)|(^\s+$)/g, "")) {
        invoiceSystemV2PurchaseReturned(this.rowId, params).then((res) => {
          // console.log("退回", res);
          this.reasonDialog = true;

          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error",
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "退回成功",
                type: "success",
              });
              this.handleList();
              this.lookDialog = false;
              this.rowId = "";
              this.refuseReason = "";
            }, 2000);
            this.reasonDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error",
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
              this.handleList();
            }, 2000);
            this.reasonDialog = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写拒绝理由",
          type: "error",
        });
      }
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave() { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      // console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    choseWorkServiceItem() {
      // console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then((res) => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        // console.log(res);
        // console.log(data);
      });
      this.serviceItem = "";
    },
    choseServiceItem(data) {
      // console.log(data);
      this.serviceItemId = data;
      // console.log(this.serviceItemId);
    },
    userPass(row) {
      // console.log(row);
      let obj = {};
      obj.id = row.id;
      userPass(obj).then((res) => {
        this.handleList();
      });
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then((res) => {
          this.handleList();
        });
      });
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            // console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          // console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      // console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success",
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    serviceListing(row) {
      // this.$router.push({path:"stockForm"})
      // console.log(row.id, "099");
      // invoiceSystemV2PurchaseDetail(mockid).then(res =>{
      // console.log("stockdetail",res)
      // })
      this.$router.push({
        name: "采购出库单",
        params: { id: row.id },
      });
      // this.$router.push({ name: "采购出库单", path: "/salesCloud/stockForm" ,query:{ id: row.id}});
    },
    formmaterImage(row) {
      let str = new Array();
      // console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelWorkOrder(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    //下载文件

    downloadExcelStockRemoval() {
      let params = this.downloadData;
      invoiceSystemV2PurchaseDownloadExcel(params).then((res) => {
        window.open(res);
      });
    },
    doPrint() {
      this.isPrint = true;
      this.companyName = getCompany();
      this.$nextTick(() => {
        var printBox = document.getElementById("printBox");
        //拿到打印的区域的html内容
        var newContent = printBox.innerHTML;
        //将旧的页面储存起来，当打印完成后返给给页面。
        var oldContent = document.body.innerHTML;
        //赋值给body
        document.body.innerHTML = newContent;
        //执行window.print打印功能
        window.print();
        // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
        document.body.innerHTML = oldContent;
        window.location.reload(false);
        return false;
      });
    },
    doPdf() {
      downloadPDF(this.rowId);
      // let params = {};
      // let url = `/joins-invoice-system/v1/purchase/exportPdf`;
      // jsPDF(url, params);

      // printJS({
      //   printable: "docs/printjs.pdf",
      //   type: "pdf",
      //   showModal: true
      // });
      // console.log("111");
    },

    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      invoiceSystemV2Purchase(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        params.startTime = "";
        params.endTime = "";
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map((item) => {
          item.createTime = item.createTime
            ? formatterDateToUTC(item.createTime)
            : "";
          item.payTime = item.payTime ? formatterDateToUTC(item.payTime) : "";
          item.remarks = item.remarks ? item.remarks : "";
          if (item.status == "WAIT_PAY") {
            item.status = "待付款";
          } else if (item.status == "WAIT_OUT") {
            item.status = "待出库";
          } else if (item.status == "WAIT_CONFIRM") {
            item.status = "待收货";
          } else if (item.status == "RETURNED") {
            item.status = "已退回";
          } else if (item.status == "FINISH") {
            item.status = "已完成";
          } else if (item.status == "INVALID") {
            item.status = "已失效";
          } else if (item.status == "CANCELED") {
            item.status = "已取消";
          } else if (item.status == "WAIT_REFUND") {
            item.status = "待退款";
          } else {
            item.status = "error" + item.status;
          }
          if (item.payStatus == "WAIT_PAY") {
            item.payStatus = "待付款";
          } else if (item.payStatus == "WAIT_OUT") {
            item.payStatus = "待出库";
          } else if (item.payStatus == "WAIT_CONFIRM") {
            item.payStatus = "待收货";
          } else if (item.payStatus == "RETURNED") {
            item.payStatus = "已退回";
          } else if (item.payStatus == "FINISH") {
            item.payStatus = "已完成";
          } else if (item.payStatus == "INVALID") {
            item.payStatus = "已失效";
          } else if (item.payStatus == "CANCELED") {
            item.payStatus = "已取消";
          } else if (item.payStatus == "WAIT_REFUND") {
            item.payStatus = "待退款";
          } else {
            item.payStatus = "error" + item.payStatus;
          }
          return item;
        });

        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "number", displayName: "采购出库单编号" },
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "address", displayName: "店铺地址" },
            { field: "price", displayName: "采购金额" },
            // { field: "createTime", displayName: "采购时间" },
            { field: "status", displayName: "采购订单状态" },
            { field: "payStatus", displayName: "支付状态" },
            { field: "payTime", displayName: "支付时间" },
            { field: "remarks", displayName: "退回原因" },
          ],
          maxWidth: "100%",
          // 页边距为0
          style:'@page {size:A4 landscape;margin: 0;}',
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 20px;
  font-size: 14px;
  color: #333;

  .content {
    border: none;

    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }

      .titleLi .d {
        width: 300px;

        span {
          margin-right: 10px;
        }
      }
    }
  }

  .title {
    position: relative;
    left: 50%;
    border: none;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }

  .btn {
    position: absolute;
    bottom: 20px;
    left: 0;
    border: none;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    button {
      margin: 0 20px;
    }
  }
}

.avue-crud {
  margin-right: 0;
  margin: 0;
}

.print {
  display: none;
}
</style>

<style lang="scss">
@media print {
  #printTime {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  #printBox {
    position: relative;
    left: 0;
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #333;
  }

  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #333;
  }

  .el-table th {
    // border-top: 1px solid #333;
  }

  .el-table--border,
  .el-table--group {
    border: 1px solid #333;
  }

  .el-table--enable-row-transition {
    border: 1px solid #333;
  }

  #printTitle {
    position: relative;
    border: none;
    left: 50%;
    font-weight: Medium;
    font-size: 22px;
    margin-bottom: 30px;
    color: #333;
    margin-left: -37px;
  }

  #noprint {
    display: none;
  }

  .avue-crud {
    margin-right: 0;
    margin: 0;
    width: 900px;
  }

  #content {
    color: #333;
    border: none;
    margin-left: 6%;

    ul {
      .titleLi {
        display: flex;
        justify-content: flex-start;
      }

      .titleLi span {
        margin-left: 10px;
        color: #333;
      }

      .titleLi .d {
        width: 345px;
      }
    }
  }
}

.print {
  display: block;
}</style>